import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { arrayOf, string, number, oneOfType, bool, func } from 'prop-types';
import MediaThumbnails from './MediaThumbnails';
import MediaCarousel from './MediaCarousel';

const MediaGallery = _ref => {
  let {
    alt,
    title,
    audios,
    images,
    podcasts,
    videos,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showThumbnail,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["alt", "title", "audios", "images", "podcasts", "videos", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showThumbnail", "showMoreTooltip", "smallThumbnails", "lazy", "preload"]);

  const GalleryType = showThumbnail ? MediaThumbnails : MediaCarousel;
  const [video] = videos;
  const [audio] = [...podcasts, ...audios];
  const showMedia = !!video || !!audio;
  return /*#__PURE__*/React.createElement(GalleryType, _extends({
    alt: alt,
    title: title,
    audio: audio,
    video: video,
    images: images,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    imgMaxHeight: imgMaxHeight,
    onImageClick: onImageClick,
    onAudioClick: onAudioClick,
    onVideoClick: onVideoClick,
    onImageChange: onImageChange,
    showMedia: showMedia,
    showMoreTooltip: showMoreTooltip,
    smallThumbnails: smallThumbnails,
    preload: preload
  }, props));
};

process.env.NODE_ENV !== "production" ? MediaGallery.propTypes = {
  audios: arrayOf(string),
  images: arrayOf(string),
  podcasts: arrayOf(string),
  videos: arrayOf(string),
  imgWidth: number,
  imgHeight: number,
  imgMaxHeight: oneOfType([number, string]),
  counterSeparator: string,
  showCounter: bool,
  alt: string,
  title: string,
  onImageChange: func,
  onImageClick: func,
  onVideoClick: func,
  onAudioClick: func,
  showThumbnail: bool,
  showMoreTooltip: string,
  smallThumbnails: bool,
  lazy: bool,
  preload: bool
} : void 0;
MediaGallery.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  onImageChange: () => {},
  onImageClick: () => {},
  onVideoClick: () => {},
  onAudioClick: () => {},
  showThumbnail: false,
  showMoreTooltip: '',
  smallThumbnails: false,
  lazy: false,
  preload: false
};
export default MediaGallery;